'use strict';

$(document).ready(function () {
    $(document).on('input', '.form-group .form-control', function () {
        if ($(this).val().length === 0) {
            $(this).siblings('.placeholder').removeClass('d-none');
        } else {
            $(this).siblings('.placeholder').addClass('d-none');
        }
    });

    $(document).on('blur', '.form-group .form-control', function () {
        if ($(this).val().length === 0) {
            $(this).siblings('.placeholder').removeClass('d-none');
        }
    });

    $(document).on('click', '.form-group .placeholder', function () {
        $(this).siblings('.form-control').focus();
    });
});
